import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { Home, ArrowLeft, Search } from 'lucide-react';

export const NotFound = () => {
  useEffect(() => {
    // Set the page title to indicate 404 for crawlers
    document.title = 'Page Not Found — EnergiPro Solutions';
    // Tell search engines not to index this page
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'noindex, nofollow');
    return () => {
      // Clean up on unmount
      if (meta) meta.setAttribute('content', 'index, follow');
    };
  }, []);

  return (
    <Layout>
      <div className="min-h-[70vh] flex items-center justify-center bg-gradient-to-b from-slate-900 to-slate-800">
        <div className="text-center px-4 max-w-lg">
          <div className="mb-8">
            <span className="text-8xl font-bold text-orange-500/20 font-['Oswald']">404</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Page Not Found
          </h1>
          <p className="text-slate-400 text-lg mb-8 leading-relaxed">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white font-bold rounded-sm transition-all duration-300 hover:-translate-y-0.5"
            >
              <Home size={18} />
              Go Home
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 bg-transparent border-2 border-white/40 hover:border-white text-white font-bold rounded-sm transition-all duration-300 hover:-translate-y-0.5"
            >
              <Search size={18} />
              Contact Us
            </Link>
          </div>
          <div className="mt-12 pt-8 border-t border-slate-700">
            <p className="text-slate-500 text-sm">Quick Links</p>
            <div className="flex flex-wrap justify-center gap-4 mt-3">
              <Link to="/services" className="text-slate-400 hover:text-orange-400 text-sm transition-colors">Services</Link>
              <Link to="/projects" className="text-slate-400 hover:text-orange-400 text-sm transition-colors">Projects</Link>
              <Link to="/about" className="text-slate-400 hover:text-orange-400 text-sm transition-colors">About</Link>
              <Link to="/tender-support" className="text-slate-400 hover:text-orange-400 text-sm transition-colors">Tender Support</Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
